"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenListItem = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Types_1 = require("Tokens/Types");
var Util_1 = require("@CommonFrontend/Tokens/Util");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TokenListItem = (function (_super) {
    __extends(TokenListItem, _super);
    function TokenListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenListItem.prototype.render = function () {
        var children = this.props.children;
        return (react_1.default.createElement("div", { className: "token-list-item" },
            react_1.default.createElement("div", { className: "token-list-item__content" }, children),
            this.renderActions()));
    };
    TokenListItem.prototype.renderActions = function () {
        var token = this.props.token;
        return (react_1.default.createElement("div", { className: "token-list-item__actions" },
            this.shouldAllowCopy(token) && (react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: (0, Util_1.serialiseVariableAsText)(token) }, function (_a) {
                var onCopy = _a.onCopy;
                return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: "token-list-item__action-btn", icon: react_1.default.createElement(icons_1.Copy, null), size: kaleidoscope_1.ButtonSize.Small, onClick: onCopy }));
            })),
            this.renderOptionMenu()));
    };
    TokenListItem.prototype.renderOptionMenu = function () {
        var _a = this.props, token = _a.token, onDelete = _a.onDelete, onShowProperties = _a.onShowProperties;
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "tokens-panel__option-menu token-list-item__option-menu nested-portal", button: react_1.default.createElement(kaleidoscope_1.IconButton, { className: "token-list-item__action-btn", "aria-label": "More options", icon: react_1.default.createElement(icons_1.OptionsVertical, null), size: kaleidoscope_1.ButtonSize.Small }), autoStack: true },
            react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: token.apiReference }, function (_a) {
                var onCopy = _a.onCopy;
                return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { closeOnClick: false, onClick: onCopy }, "Copy API reference"));
            }),
            !!onShowProperties && (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () { return onShowProperties(token); } }, "Item properties")),
            !!onDelete && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { destructive: true, onClick: function () { return onDelete(token); } }, "Delete")))));
    };
    TokenListItem.prototype.shouldAllowCopy = function (token) {
        return (0, Types_1.isNotPlatformProductToken)(token);
    };
    TokenListItem = __decorate([
        mobx_react_1.observer
    ], TokenListItem);
    return TokenListItem;
}(react_1.default.Component));
exports.TokenListItem = TokenListItem;
